export function scrollToBottom(
  containerRef: React.RefObject<HTMLDivElement>,
  delay = 0,
) {
  if (containerRef.current) {
    const scrollFn = () =>
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    if (delay > 0) {
      setTimeout(scrollFn, delay);
    } else {
      scrollFn();
    }
  }
}
